import React from 'react';
import { RoutingStep } from '../../../../../../../../../../../../models/Routes';
import WorkflowAcceptPage from './pages/WorkflowAcceptPage';
import WorkflowConfirmPage from './pages/WorkflowConfirmPage';
import WorkflowEnquirePage from './pages/WorkflowEnquirePage';
import WorkflowOfferPage from './pages/WorkflowOfferPage';
import { Navigate } from 'react-router-dom';

export default [
  {
    path: 'enquire',
    element: WorkflowEnquirePage,
    labelId: 'enquire',
    stepName: 'enquire',
  },
  {
    path: 'accept',
    element: WorkflowAcceptPage,
    labelId: 'accept',
    stepName: 'accept',
  },
  {
    path: 'confirm',
    element: WorkflowConfirmPage,
    labelId: 'confirm',
    stepName: 'confirm',
  },
  {
    path: 'offer',
    element: WorkflowOfferPage,
    labelId: 'offer',
    stepName: 'offer',
  },
  {
    index: true,
    element: <Navigate to="enquire" replace />,
  },
] as Array<RoutingStep>;
